import type { SVGProps } from "react";
const SvgNotification01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M4.299 9.576c-.062 1.163.009 2.401-1.03 3.181a1.92 1.92 0 0 0-.769 1.537c0 .832.652 1.54 1.5 1.54h12c.849 0 1.5-.708 1.5-1.54 0-.605-.285-1.174-.768-1.537-1.04-.78-.97-2.018-1.03-3.181a5.71 5.71 0 0 0-11.403 0"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.25}
      d="M8.75 2.604c0 .69.56 1.563 1.25 1.563s1.25-.873 1.25-1.563-.56-.937-1.25-.937-1.25.247-1.25.937Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M12.5 15.833a2.5 2.5 0 0 1-5 0"
    />
  </svg>
);
export default SvgNotification01;
